import { createSelector } from 'reselect';
import TypeItem from 'records/TypeItem';
import { types } from 'constants/types';

const getItemTypes = (state) => state.typeItems.get('data');

export const getFoodItemTypes = createSelector(
  [getItemTypes],
  (typeItems) => {
    return TypeItem.getActiveTypeItemsByType(typeItems, types.FOOD.TYPE_ID);
  }
);

export const getBusinessItemTypes = createSelector(
  [getItemTypes],
  (typeItems) => {
    return TypeItem.getActiveTypeItemsByType(typeItems, types.BUSINESS.TYPE_ID);
  }
);

export const getDesignItemTypes = createSelector(
  [getItemTypes],
  (typeItems) => {
    return TypeItem.getActiveTypeItemsByType(typeItems, types.DESIGN.TYPE_ID);
  }
);

export const getMenuItemSizeItemTypes = createSelector(
  [getItemTypes],
  (typeItems) => {
    return TypeItem.getActiveTypeItemsByType(typeItems, types.MENU_ITEM_SIZE.TYPE_ID);
  }
);

export const getSpiceLevelItemTypes = createSelector(
  [getItemTypes],
  (typeItems) => {
    return TypeItem.getActiveTypeItemsByType(typeItems, types.SPICE_LEVEL.TYPE_ID);
  }
);

export const getWeightUnitTypes = createSelector(
  [getItemTypes],
  (typeItems) => {
    return TypeItem.getActiveTypeItemsByType(typeItems, types.WEIGHT_UNIT.TYPE_ID);
  }
);

export const getWeightUnitTypesInlineFormat = createSelector(
  getItemTypes,
  (typeItems) => {
    const weightTypes = TypeItem.getActiveTypeItemsByType(typeItems, types.WEIGHT_UNIT.TYPE_ID);
    const formattedTypes = [];
    weightTypes.forEach((type) => {
      formattedTypes.push({
        id: type.get('abbreviation'),
        text: type.get('abbreviation'),
      });
    });
    return formattedTypes;
  }
);

export const getDesignSizeTypes = createSelector(
  [getItemTypes],
  (typeItems) => {
    return TypeItem.getActiveTypeItemsByType(typeItems, types.DESIGN_SIZE.TYPE_ID);
  }
);

